function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.07143 5.5C2.37516 5.5 1 6.87521 1 8.57169C1 9.37842 1.31031 10.1115 1.81898 10.66L1.08578 11.34C0.412382 10.6139 0 9.64042 0 8.57169C0 6.32299 1.82281 4.5 4.07143 4.5H7.5V5.5H4.07143Z",
  fill: "#BD3030"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 13L5.5 11L5.5 12.5H11.9286C13.0506 12.5 14.0321 11.8983 14.568 11C15 11 15.6856 11 15.6856 11C15.0707 12.4684 13.6201 13.5 11.9286 13.5H5.5V15L2.5 13Z",
  fill: "#BD3030"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 9C16.4853 9 18.5 6.98528 18.5 4.5C18.5 2.01472 16.4853 0 14 0C11.5147 0 9.5 2.01472 9.5 4.5C9.5 6.98528 11.5147 9 14 9ZM14.761 2.04401V7.00001H13.634V3.67501L13.158 4.00401L12.5 3.43001L13.816 2.04401H14.761Z",
  fill: "white"
});

var SvgIconRepeatTrack = function SvgIconRepeatTrack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRepeatTrack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_repeat_track.e88a72d6.svg";
export { ForwardRef as ReactComponent };